import { IconProps } from '.';

const CameraIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      className={customClasses}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.333 20.8334C13.333 24.5154 16.3178 27.5001 19.9997 27.5001C23.6816 27.5001 26.6663 24.5154 26.6663 20.8334C26.6663 17.1515 23.6816 14.1667 19.9997 14.1667C16.3178 14.1667 13.333 17.1515 13.333 20.8334ZM19.9997 30.0001C14.9371 30.0001 10.833 25.8961 10.833 20.8334C10.833 15.7708 14.9371 11.6667 19.9997 11.6667C25.0623 11.6667 29.1663 15.7708 29.1663 20.8334C29.1663 25.8961 25.0623 30.0001 19.9997 30.0001Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3156 5.41675H24.6844L28.0178 8.75008H35C35.6904 8.75008 36.25 9.30973 36.25 10.0001V33.3334C36.25 34.0238 35.6904 34.5834 35 34.5834H5C4.30964 34.5834 3.75 34.0238 3.75 33.3334V10.0001C3.75 9.30973 4.30964 8.75008 5 8.75008H11.9822L15.3156 5.41675ZM16.3511 7.91675L13.0178 11.2501H6.25V32.0834H33.75V11.2501H26.9822L23.6489 7.91675H16.3511Z"
        fill={color}
      />
    </svg>
  );
};

export default CameraIcon;
